import { __assign } from "tslib";
import { getMappingVariables } from '../get-mapping-variables';
import { getMappingRegex } from './get-mapping-regex';
export var resolveMappingVariables = function (mapping, urlPath) {
    var regex = getMappingRegex(mapping);
    var matching = urlPath === null || urlPath === void 0 ? void 0 : urlPath.match(regex);
    if (matching) {
        var variables = getMappingVariables(mapping);
        var itemData = variables.reduce(function (urlSegments, currentVariable, index) {
            var _a;
            return (__assign(__assign({}, urlSegments), (_a = {}, _a[currentVariable] = matching[index + 1], _a)));
        }, {});
        return itemData;
    }
    return {};
};
//# sourceMappingURL=resolve-mapping-variables.js.map